/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ query: NonNullable<unknown> }} Eventsnosearchresults3Inputs */

const en_eventsnosearchresults3 = /** @type {(inputs: Eventsnosearchresults3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No events match “${i?.query}”`)
};

const de_eventsnosearchresults3 = /** @type {(inputs: Eventsnosearchresults3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Keine Events zu „${i?.query}“`)
};

/**
* | output |
* | --- |
* | "No events match “{query}”" |
*
* @param {Eventsnosearchresults3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventsnosearchresults3 = /** @type {((inputs: Eventsnosearchresults3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventsnosearchresults3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventsnosearchresults3(inputs)
	return de_eventsnosearchresults3(inputs)
});
export { eventsnosearchresults3 as "eventsNoSearchResults" }